import React, { ChangeEvent, SetStateAction, useContext, useEffect, useState } from "react";
import { Paper, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import { TableBody, TableHead } from "@mui/material";
import { TableContainer, TableCell, TableRow } from "@mui/material";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { del_using_obj, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { IAzotoAplicado, ICabecalho5D, IFertilizacaoOrganica } from "../../../Interfaces/cadernos/caderno5/interfaces5D";
import { fertilizante, origem, pecuaria, unidade_medida_Kg_m3 } from "../../../informacao_estatica";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface IAzotoAplicadoProps {
  cabecalho: ICabecalho5D | undefined;
  set_obj_organica: React.Dispatch<SetStateAction<IFertilizacaoOrganica | undefined>>;
  total_quant3: number;
  set_total_quant3: React.Dispatch<SetStateAction<number>>;
  rowsAzoto: IAzotoAplicado[];
  setRowsAzoto: React.Dispatch<React.SetStateAction<IAzotoAplicado[]>>;
  rowsAzoto_filtrada: IAzotoAplicado[];
  setRowsAzoto_filtrada: React.Dispatch<React.SetStateAction<IAzotoAplicado[]>>;
}

export const AzotoAplicadoForm: React.FC<IAzotoAplicadoProps> = ({
  cabecalho,
  set_obj_organica,
  total_quant3,
  set_total_quant3,
  rowsAzoto,
  setRowsAzoto,
  rowsAzoto_filtrada,
  setRowsAzoto_filtrada,

}) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showNewRow, setShowNewRow] = useState<boolean>(false);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");

  const [error_data, set_error_data] = useState<boolean>(false);
  const [error_quantidade_um, set_error_quantidade_um] = useState<boolean>(false);
  const [error_teor_n, set_error_teor_n] = useState<boolean>(false);


  const [openDeleteAzoto, setOpenDeleteAzoto] = React.useState<boolean>(false);

  const [total_quant2, set_total_quant2] = React.useState<number>(0);
  const [total_quant4, set_total_quant4] = React.useState<number>(0);
  const [total_quant5, set_total_quant5] = React.useState<number>(0);

  const [obj_editar, set_obj_editar] = React.useState<IAzotoAplicado | undefined>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handle_fechar_nova_linha_limpar_campos()


    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const sumatorio_das_quantidades = (lista: IAzotoAplicado[], area: number) => {

    let total_quant2_final = 0
    let total_quant2_aux

    let total_quant3_final = 0
    let total_quant3_aux

    let total_quant4_final = 0
    let total_quant4_aux

    let total_quant5_final = 0
    let total_quant5_aux

    lista.forEach((el) => {
      total_quant2_aux = calcula_quantidade_dois(el.teor_n)
      total_quant2_final += total_quant2_aux

      total_quant3_aux = calcula_quantidade_tres(el.teor_n, el.quantidade_um)
      total_quant3_final += total_quant3_aux

      total_quant4_aux = calcula_quantidade_quatro(area, el.quantidade_um)
      total_quant4_final += total_quant4_aux

      total_quant5_aux = calcula_quantidade_cinco(area, el.teor_n, el.quantidade_um)
      total_quant5_final += total_quant5_aux

    })

    set_total_quant2(total_quant2_final)
    set_total_quant3(total_quant3_final)
    set_total_quant4(total_quant4_final)
    set_total_quant5(total_quant5_final)


  }

  const calcula_quantidade_dois = (valor: number) => {
    if (Number.isNaN(valor)) {
      return 0
    } else {
      return (valor * 1000000) / 100
    }
  }
  const calcula_quantidade_tres = (teor_n: number, quantidade_um: number) => {
    if (Number.isNaN(teor_n) || Number.isNaN(quantidade_um)) {
      return 0
    } else {
      let quant_2_aux = calcula_quantidade_dois(teor_n)
      let quant_2_final = typeof (quant_2_aux) === 'number' ? quant_2_aux : 0
      return quant_2_final * 0.000001 * quantidade_um
    }
  }
  const calcula_quantidade_quatro = (area: number, quantidade_um: number) => {
    if (Number.isNaN(area) || Number.isNaN(quantidade_um)) {
      return 0
    } else {
      return quantidade_um * area
    }



  }
  const calcula_quantidade_cinco = (area: number, teor_n: number, quantidade_um: number) => {
    if (Number.isNaN(teor_n) || Number.isNaN(area) || Number.isNaN(quantidade_um)) {
      return 0
    } else {
      let quant_3_aux = calcula_quantidade_tres(teor_n, quantidade_um)
      let quant_3_final = typeof (quant_3_aux) === 'number' ? quant_3_aux : 0
      return quant_3_final * area
    }
  }

  async function getAzoto() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_act_fertil_azotada_um_5d_cabecalho/${cabecalho?.id_act_feertil_azotada}`);
      if (res.status === 200) {
        setRowsAzoto(res.data.result);
        setRowsAzoto_filtrada(res.data.result);
        if (cabecalho?.area !== undefined) {
          sumatorio_das_quantidades(res.data.result, cabecalho?.area)
        }
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAzoto", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getAzoto();
    })();
  }, [cabecalho?.id_act_feertil_azotada]);


  const handle_fechar_nova_linha_limpar_campos = () => {
    set_obj_editar(undefined);
    set_error_data(false);
    set_error_quantidade_um(false)
    set_error_teor_n(false)
    setShowNewRow(false);
    if (cabecalho?.area !== undefined) {
      sumatorio_das_quantidades(rowsAzoto, cabecalho?.area)
    }
  }


  // CRIAR
  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)


    if (name === "data_aplica") {
      if (value === undefined || value === "") {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
      set_obj_editar((prevManeio: any) => ({
        ...prevManeio,
        [name]: value,
      }));
    } else if (name === "quantidade_um") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_quantidade_um(true);

      } else {
        set_error_quantidade_um(false);

        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

        let aux_quant3 = obj_editar?.teor_n === undefined ? 0 : calcula_quantidade_tres(obj_editar?.teor_n, aux_value)
        let aux_quant4 = cabecalho?.area === undefined ? 0 : calcula_quantidade_quatro(cabecalho?.area, aux_value)
        let aux_quant5 = obj_editar?.teor_n === undefined || cabecalho?.area === undefined ? 0 : calcula_quantidade_cinco(cabecalho?.area, obj_editar?.teor_n, aux_value)

        set_obj_editar((prevManeio: any) => ({
          ...prevManeio,
          ['quantidade_tres']: aux_quant3,
          ['quantidade_quatro']: aux_quant4,
          ['quantidade_cinco']: aux_quant5,
          ['quantidade_um']: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "teor_n") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_teor_n(true);
      } else {
        set_error_teor_n(false);


        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

        let aux_quant2 = calcula_quantidade_dois(aux_value)
        let aux_quant3 = obj_editar?.quantidade_um === undefined ? 0 : calcula_quantidade_tres(aux_value, obj_editar?.quantidade_um)
        let aux_quant5 = obj_editar?.quantidade_um === undefined || cabecalho?.area === undefined ? 0 : calcula_quantidade_cinco(cabecalho?.area, aux_value, obj_editar?.quantidade_um)
        set_obj_editar((prevManeio: any) => ({
          ...prevManeio,
          ['quantidade_dois']: aux_quant2,
          ['quantidade_tres']: aux_quant3,
          ['quantidade_cinco']: aux_quant5,
          ['teor_n']: format_strings_to_numbers(value, false),
        }));

      }
    } else {
      set_obj_editar((prevManeio: any) => ({
        ...prevManeio,
        [name]: value,
      }));
    }


  };

  const handleSaveAzoto = async () => {

    if (obj_editar?.data_aplica === undefined || obj_editar?.data_aplica === "" || obj_editar?.quantidade_um === undefined) {
      if (obj_editar?.data_aplica === undefined || obj_editar?.data_aplica === "") {
        set_error_data(true);
      }
      if (obj_editar?.quantidade_um === undefined) {
        set_error_quantidade_um(true);
      }

      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_act_fertil_azotada_um_5d", {
          payload: {
            id_registo_fertil_um: 0,
            origem: obj_editar?.origem === undefined ? null : obj_editar?.origem,
            tipo_ferti: obj_editar?.tipo_ferti === undefined ? null : obj_editar?.tipo_ferti,
            nome_comercial: obj_editar?.nome_comercial === undefined ? null : obj_editar?.nome_comercial,
            especi_pecuaria: obj_editar?.especi_pecuaria === undefined ? null : obj_editar?.especi_pecuaria,
            data_aplica: obj_editar?.data_aplica === undefined ? null : obj_editar?.data_aplica,
            quantidade_um: obj_editar?.quantidade_um === undefined ? 0 : obj_editar?.quantidade_um,
            teor_n: obj_editar?.teor_n === undefined ? 0 : obj_editar?.teor_n,
            quantidade_dois: obj_editar?.quantidade_dois === undefined ? 0 : obj_editar?.quantidade_dois,
            quantidade_tres: obj_editar?.quantidade_tres === undefined ? 0 : obj_editar?.quantidade_tres,
            quantidade_quatro: obj_editar?.quantidade_quatro === undefined ? 0 : obj_editar?.quantidade_quatro,
            quantidade_cinco: obj_editar?.quantidade_cinco === undefined ? 0 : obj_editar?.quantidade_cinco,
            total: total_quant3 + obj_editar?.quantidade_tres,
            medida: obj_editar?.medida === undefined ? null : obj_editar.medida,
            id_act_feertil_azotada: cabecalho?.id_act_feertil_azotada,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");

          const resultArray = rowsAzoto
          // resultArray.push(res.data.result)
          resultArray.push(res.data.result[0])

          if (res.data.result[1]) {
            set_obj_organica(res.data.result[1]);
          }
          if (cabecalho?.area !== undefined) {
            sumatorio_das_quantidades(resultArray, cabecalho?.area)
          }
          setRowsAzoto(resultArray)
          setRowsAzoto_filtrada(resultArray)
          set_flag_editado(false)

          set_obj_editar(undefined);
          setShowNewRow(false);
          setOpenSnackSuccess(true);

        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error: any) {
        func_print("handleSaveAzoto", error, true);
        // if (error?.status === 409) {

        //   setMessage(error?.response.data.detail);
        //   setOpenSnackError(true);
        // } else {
        //   setMessage("Erro ao efetuar a sua operação!");
        //   setOpenSnackError(true);
        // }
        if ((error as any)?.response?.data?.message) {
          setMessage((error as any).response.data.message);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
        }
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  }

  // EDITAR
  const handleUpdateAzoto = async () => {
    if (obj_editar?.quantidade_um === undefined || obj_editar?.quantidade_um.toString() === "") {
      set_error_quantidade_um(true);
      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
    }

    try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "update_reg_act_fertil_azotada_um_5d", {
        payload: {
          id_registo_fertil_um: obj_editar?.id_registo_fertil_um,
          origem: obj_editar?.origem === undefined ? null : obj_editar.origem,
          tipo_ferti: obj_editar?.tipo_ferti === undefined ? null : obj_editar.tipo_ferti,
          nome_comercial: obj_editar?.nome_comercial === undefined ? null : obj_editar.nome_comercial,
          especi_pecuaria: obj_editar?.especi_pecuaria === undefined ? null : obj_editar.especi_pecuaria,
          data_aplica: obj_editar?.data_aplica === undefined ? null : obj_editar.data_aplica,
          quantidade_um: obj_editar?.quantidade_um === undefined ? null : obj_editar.quantidade_um,
          teor_n: obj_editar?.teor_n === undefined ? null : obj_editar.teor_n,
          quantidade_dois: obj_editar?.quantidade_dois === undefined ? null : obj_editar.quantidade_dois,
          quantidade_tres: obj_editar?.quantidade_tres === undefined ? null : obj_editar.quantidade_tres,
          quantidade_quatro: obj_editar?.quantidade_quatro === undefined ? null : obj_editar.quantidade_quatro,
          quantidade_cinco: obj_editar?.quantidade_cinco === undefined ? null : obj_editar.quantidade_cinco,
          total: obj_editar?.quantidade_tres === undefined ? null : total_quant3 + obj_editar?.quantidade_tres,
          medida: obj_editar?.medida === undefined ? null : obj_editar.medida,
          id_act_feertil_azotada: obj_editar?.id_act_feertil_azotada,
          last_update: new Date().toISOString(),
          create_date: obj_editar?.create_date,
          uuid: obj_editar?.uuid,
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        let aux_obj_network_azoto = res.data.result[0]
        let aux_obj_network_organica = res.data.result[1]

        if (aux_obj_network_azoto) {
          const updatedRows = rowsAzoto.map((row) =>
            row.id_registo_fertil_um === aux_obj_network_azoto.id_registo_fertil_um
              ? aux_obj_network_azoto
              : row
          );
          setRowsAzoto(updatedRows !== undefined ? updatedRows : []);
          setRowsAzoto_filtrada(updatedRows !== undefined ? updatedRows : []);
          if (cabecalho?.area !== undefined) {
            sumatorio_das_quantidades(updatedRows, cabecalho?.area)
          }

        }

        if (aux_obj_network_organica) {
          set_obj_organica(aux_obj_network_organica);
        }


        set_obj_editar(undefined);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleUpdateAzoto", error, true);
      if (error?.status === 409) {

        setMessage(error?.response.data.detail);
        setOpenSnackError(true);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    }

  };

  // DELETE
  const handleClickOpenDeleteAzoto = (obj: IAzotoAplicado) => {
    set_obj_editar(obj);
    setOpenDeleteAzoto(true);
  };

  const handleDeleteAzoto = async () => {
    try {
      setIsLoading(true);
      let res = await del_using_obj(auth.token.cookie_token, `delete__reg_act_fertil_azotada_um_5d`, {
        payload:
        {
          id_registo_fertil_um: obj_editar?.id_registo_fertil_um,
          origem: obj_editar?.origem === undefined ? null : obj_editar.origem,
          tipo_ferti: obj_editar?.tipo_ferti === undefined ? null : obj_editar.tipo_ferti,
          nome_comercial: obj_editar?.nome_comercial === undefined ? null : obj_editar.nome_comercial,
          especi_pecuaria: obj_editar?.especi_pecuaria === undefined ? null : obj_editar.especi_pecuaria,
          data_aplica: obj_editar?.data_aplica === undefined ? null : obj_editar.data_aplica,
          quantidade_um: obj_editar?.quantidade_um === undefined ? null : obj_editar.quantidade_um,
          teor_n: obj_editar?.teor_n === undefined ? null : obj_editar.teor_n,
          quantidade_dois: obj_editar?.quantidade_dois === undefined ? null : obj_editar.quantidade_dois,
          quantidade_tres: obj_editar?.quantidade_tres === undefined ? null : obj_editar.quantidade_tres,
          quantidade_quatro: obj_editar?.quantidade_quatro === undefined ? null : obj_editar.quantidade_quatro,
          quantidade_cinco: obj_editar?.quantidade_cinco === undefined ? null : obj_editar.quantidade_cinco,
          total: obj_editar?.quantidade_tres === undefined ? null : total_quant3 - obj_editar?.quantidade_tres,
          medida: obj_editar?.medida === undefined ? null : obj_editar.medida,
          id_act_feertil_azotada: cabecalho?.id_act_feertil_azotada,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: obj_editar?.uuid === undefined ? null : obj_editar.uuid,
        }
      });
      if (res.status === 200) {
        setMessage("Eliminado com sucesso!");

        if (Object.keys(res.data.result[0]).length === 0 && Object.keys(res.data.result[1]).length === 0) {
          if (cabecalho?.area !== undefined) {
            sumatorio_das_quantidades([], cabecalho?.area)
          }
          set_obj_organica(undefined)
          setRowsAzoto([])
          setRowsAzoto_filtrada([])
          setOpenDeleteAzoto(false);
          set_obj_editar(undefined);
          setOpenSnackSuccess(true);
        } else {

          let aux_array = rowsAzoto.filter((row) => row.id_registo_fertil_um !== obj_editar?.id_registo_fertil_um);

          if (cabecalho?.area !== undefined) {
            sumatorio_das_quantidades(aux_array, cabecalho?.area)
          }
          let aux_obj_network_organica = res.data.result[1]
          if (aux_obj_network_organica) {
            set_obj_organica(aux_obj_network_organica);
          }

          setRowsAzoto(aux_array)
          setRowsAzoto_filtrada(aux_array)
          setOpenDeleteAzoto(false);
          set_obj_editar(undefined);
          setOpenSnackSuccess(true);
        }

      } else {
        setMessage("Erro ao eliminar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteAzoto", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  /*****************  PAGINAÇÃO ********************** */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rowsAzoto_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomThemeProvider>
      {isLoading ?
        <LoadingVulpes /> :

        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <table style={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={10}
                  sx={{ fontWeight: 600, textAlign: "left", fontFamily: "candara", fontSize: 16, }} >
                  <Stack direction="row" alignItems="center">
                    1- Quantidade de Azoto aplicada
                    <BasicPopover text={"Quadro de preenchimento obrigatório para:\n\n- Beneficiários candidatos ao regime ecológico «promoção da fertilização orgânica»;\n\n- As explorações em Zona Vulnerável para cumprimento do disposto na alínea a) do n.º 9 do artigo 8.º da Portaria n.º 259/2012, caso o beneficiário opte pelo registo em CCU."} />
                  </Stack>
                </TableCell>
                <TableCell colSpan={2}>
                  {is_historico === true ? <></> :

                    <BarraDeFerramentas
                      mostrarBotaoNovo
                      textoBotaoNovo="Novo Registo"
                      aoClicarNovo={() => {
                        setShowNewRow(true)
                        set_obj_editar(undefined)
                      }}
                    />}
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead sx={{ minWidth: 180 }}>
                  Origem dos
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Nutrientes
                    <BasicPopover text={"Valores possíveis:\n- Água de rega;\n- Fertilização de Fundo com Fertilizantes Orgânicos;\n- Fertilização de Fundo com Fertilizantes Inorgânicos;\n- Fertilização de Cobertura com Fertilizantes Orgânicos; \n- Fertilização de Cobertura com Fertilizantes Inorgânicos.\n\nPreenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica»."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead sx={{ minWidth: 150 }}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Tipo de Fertilizantes
                    <BasicPopover text={"Valores possíveis:\n- Estrume; \n- Chorume; \n- Mistura de fluentes pecuários;\n- Digerido de Unidade de Biogás; \n- Sedimentos depositados nas lagoas de armazenamento de efluentes pecuários;\n- Composto com origem em efluentes pecuários ou seus equiparados;\n- Outro tipo de Composto;\n- Outro tipo de Fertilizante Orgânico; \n- Fertilizante de síntese;"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead sx={{ minWidth: 180 }}>Nome Comercial/ Origem da M.O.</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 120 }}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Espécie pecuária
                    <BasicPopover text={"Preencher quando se trate de efluente pecuário. \n\nValores possíveis:  \n- Bovino; \n - Suíno; \n - Ovino; \n- Caprino;\n - Aves;  \n - Equídeos; \n - Leporídeos; \n - Outras espécies pecuárias."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Data da Aplicação*
                    <BasicPopover text={"Valor deverá assumir o formato dd-mm-aaaa."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Quantidade de fertilizante aplicada/ha(kg ou m3/ha)*
                    <BasicPopover
                      text={"Os registos efetuados neste campo devem atender ao previsto no plano de fertilização (Anexo I)."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Teor em N(%)
                    <BasicPopover text={"Campo de preenchimento manual."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}>
                  Quantidade N(total)/kg ou m3 fertilizante (mg N(total)/kg ou m3)
                </StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Quantidade N(total) aplicada/ha(k/ha)
                    <BasicPopover text={"Portaria n.º 259/2012 - campo de preenchimento obrigatório."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}>
                  Quantidade total de fertilizante aplicada (kg ou m3)
                </StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}>
                  Quantidade total de azoto (N(total) aplicada (kg))
                </StyledTableHead>
                <StyledTableHead>Ações</StyledTableHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {showNewRow && (
                <TableRow>
                  <StyledTableCell>
                    <CustomSelect
                      value={obj_editar?.origem === undefined ? "" : obj_editar.origem}
                      name="origem"
                      onChange={onInputChange}
                      options={origem}
                      label="Origem dos Nutrientes"
                      minWidth={120}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomSelect
                      value={obj_editar?.tipo_ferti === undefined ? "" : obj_editar.tipo_ferti}
                      name="tipo_ferti"
                      onChange={onInputChange}
                      options={fertilizante}
                      label="Tipo de Fertilizante"
                      minWidth={120}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="nome_comercial"
                      value={obj_editar?.nome_comercial === undefined ? "" : obj_editar.nome_comercial}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomSelect
                      value={obj_editar?.especi_pecuaria === undefined ? "" : obj_editar.especi_pecuaria}
                      name="especi_pecuaria"
                      onChange={onInputChange}
                      options={pecuaria}
                      label="Espécie pecuária"
                      minWidth={120}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      variant="filled"
                      type="date"
                      name="data_aplica"
                      value={obj_editar?.data_aplica === undefined ? "" : obj_editar.data_aplica}
                      onChange={onInputChange as (event: React.ChangeEvent<HTMLInputElement>) => void}
                      error={error_data}
                      helperText={error_data ? "Preencha este campo" : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" alignItems="center">
                      <CustomTextField
                        name="quantidade_um"
                        value={obj_editar?.quantidade_um != null ? obj_editar.quantidade_um.toString().replace('.', ',') : ""}
                        onChange={onInputChange}
                        error={error_quantidade_um}
                        helperText={error_quantidade_um ? message_apenas_numero : ""}
                      />
                      <CustomSelect
                        value={obj_editar?.medida !== undefined ? obj_editar.medida : ""}
                        name="medida"
                        onChange={onInputChange}
                        options={unidade_medida_Kg_m3}
                        label="UM"
                        minWidth={50}
                      />
                    </Stack>
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="teor_n"
                      value={obj_editar?.teor_n != null ? obj_editar.teor_n.toString().replace('.', ',') : ""}
                      onChange={onInputChange}
                      error={error_teor_n}
                      helperText={error_teor_n ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    {obj_editar?.quantidade_dois === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_dois)}
                  </StyledTableCell>
                  <StyledTableCell>
                    {obj_editar?.quantidade_tres === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_tres)}
                  </StyledTableCell>
                  <StyledTableCell>
                    {obj_editar?.quantidade_quatro === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_quatro)}
                  </StyledTableCell>
                  <StyledTableCell >
                    {obj_editar?.quantidade_cinco === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_cinco)}
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center">
                      <ButtonCadernos
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handle_fechar_nova_linha_limpar_campos()
                          }
                        }}
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleSaveAzoto()}
                      />
                    </Stack>
                  </StyledTableCell>
                </TableRow>
              )}

              {(rowsPerPage > 0
                ? rowsAzoto_filtrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rowsAzoto_filtrada
              ).map((row, key) => {
                return (
                  <TableRow key={key}>
                    {obj_editar?.id_registo_fertil_um === row.id_registo_fertil_um ? (
                      <>
                        <StyledTableCell>
                          <CustomSelect
                            value={obj_editar?.origem === undefined ? '' : obj_editar?.origem}
                            name={"origem"}
                            onChange={(event) => onInputChange(event)}
                            options={origem}
                            label="Origem dos Nutrientes"
                            minWidth={120}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomSelect
                            value={obj_editar?.tipo_ferti === undefined ? '' : obj_editar?.tipo_ferti}
                            name="tipo_ferti"
                            onChange={(event) => onInputChange(event)}
                            options={fertilizante}
                            label="Tipo de Fertilizante"
                            minWidth={120}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="nome_comercial"
                            value={obj_editar?.nome_comercial === undefined ? '' : obj_editar?.nome_comercial}
                            onChange={(event: any) => onInputChange(event)}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomSelect
                            value={obj_editar?.especi_pecuaria === undefined ? '' : obj_editar?.especi_pecuaria}
                            name="especi_pecuaria"
                            onChange={(event) => onInputChange(event)}
                            options={pecuaria}
                            label="Espécie pecuária"
                            minWidth={120}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <TextField
                            variant="filled"
                            type="date"
                            name="data_aplica"
                            value={obj_editar?.data_aplica === null ? "" : obj_editar?.data_aplica}
                            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                              onInputChange(event)
                            }
                            error={error_data}
                            helperText={error_data ? "Preencha este campo" : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <Stack direction="row" alignItems="center">
                            <CustomTextField
                              name="quantidade_um"
                              value={obj_editar?.quantidade_um != null ? obj_editar.quantidade_um.toString().replace('.', ',') : ""}
                              onChange={onInputChange}
                              error={error_quantidade_um}
                              helperText={error_quantidade_um ? message_apenas_numero : ""}
                            />
                            <CustomSelect
                              value={obj_editar?.medida !== undefined ? obj_editar.medida : ""}
                              name="medida"
                              onChange={onInputChange}
                              options={unidade_medida_Kg_m3}
                              label="UM"
                              minWidth={50}
                            />
                          </Stack>
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="teor_n"
                            value={obj_editar?.teor_n != null ? obj_editar.teor_n.toString().replace('.', ',') : ""}
                            onChange={onInputChange}
                            error={error_teor_n}
                            helperText={error_teor_n ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {obj_editar?.quantidade_dois === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_dois)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {obj_editar?.quantidade_tres === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_tres)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {obj_editar?.quantidade_quatro === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_quatro)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {obj_editar?.quantidade_cinco === undefined ? "0,00" : formatarNumero_recebido_com_casa_decimais(obj_editar.quantidade_cinco)}
                        </StyledTableCell>
                      </>
                    ) : (
                      <>
                        <StyledTableCell>{row.origem}</StyledTableCell>
                        <StyledTableCell>{row.tipo_ferti}</StyledTableCell>
                        <StyledTableCell>{row.nome_comercial}</StyledTableCell>
                        <StyledTableCell>{row.especi_pecuaria}</StyledTableCell>
                        <StyledTableCell>{row.data_aplica}</StyledTableCell>
                        <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quantidade_um)} {row.medida}</StyledTableCell>
                        <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.teor_n)}</StyledTableCell>
                        <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quantidade_dois)}</StyledTableCell>
                        <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quantidade_tres)}</StyledTableCell>
                        <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quantidade_quatro)}</StyledTableCell>
                        <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.quantidade_cinco)}</StyledTableCell>
                      </>
                    )}

                    {obj_editar?.id_registo_fertil_um === row.id_registo_fertil_um ? (
                      <StyledTableCell>
                        <ButtonCadernos
                          mostrarBotaoGravar
                          aoClicarGravar={() => handleUpdateAzoto()}
                          mostrarBotaoCancelar
                          aoClicarCancelar={() => {
                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                            } else {
                              handle_fechar_nova_linha_limpar_campos()
                            }
                          }}
                        />
                      </StyledTableCell>
                    ) : (
                      <StyledTableCell>
                        {is_historico === true ? <></> :

                          <ButtonCadernos
                            mostrarBotaoEditar
                            aoClicarEditar={() => {
                              set_obj_editar(row);
                              set_total_quant2(total_quant2 - row.quantidade_dois)
                              set_total_quant3(total_quant3 - row.quantidade_tres)
                              set_total_quant4(total_quant4 - row.quantidade_quatro)
                              set_total_quant5(total_quant5 - row.quantidade_cinco)
                              set_error_data(false);
                              set_error_quantidade_um(false)
                              set_error_teor_n(false)
                              setShowNewRow(false);
                            }}
                            mostrarBotaoApagar
                            aoClicarApagar={() =>
                              handleClickOpenDeleteAzoto(row)
                            }
                          />}
                      </StyledTableCell>
                    )}
                  </TableRow>
                )
              })}
              <TableRow>
                <TableCell colSpan={6}>
                  <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                    * Campos de preenchimento obrigatório
                  </Typography>
                </TableCell>
                <StyledTableCell sx={{ textAlign: "center" }}>
                  {"Total:"}
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.quantidade_dois !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(total_quant2 + obj_editar?.quantidade_dois) :
                      formatarNumero_recebido_com_casa_decimais(total_quant2)
                  }
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.quantidade_tres !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(total_quant3 + obj_editar?.quantidade_tres) :
                      formatarNumero_recebido_com_casa_decimais(total_quant3)
                  }
                </StyledTableCell>
                <StyledTableCell>{
                  obj_editar?.quantidade_quatro !== undefined ?
                    formatarNumero_recebido_com_casa_decimais(total_quant4 + obj_editar?.quantidade_quatro) :
                    formatarNumero_recebido_com_casa_decimais(total_quant4)

                }</StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.quantidade_cinco !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(total_quant5 + obj_editar?.quantidade_cinco) :
                      formatarNumero_recebido_com_casa_decimais(total_quant5)

                  }
                </StyledTableCell>
              </TableRow>
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={19} />
                </TableRow>
              )}

            </TableBody>
            <TableFooter>
              <TableRow sx={{ width: "100%" }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={14}
                  count={rowsAzoto_filtrada.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                  }}
                  labelRowsPerPage={'Linhas por página'}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </table>
        </TableContainer>
      }
      <ConfirmDialog
        open={openDeleteAzoto}
        onClose={() => setOpenDeleteAzoto(false)}
        onConfirm={handleDeleteAzoto}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </CustomThemeProvider>
  );
};